"use client";

type RouterLike = {
  push: (href: string) => void;
  replace: (href: string) => void;
};

interface NavigateToLoginOptions {
  redirectTo?: string | null;
  replace?: boolean;
}

export function sanitizeInternalPath(path: string | null | undefined): string {
  if (!path) return "/";
  if (!path.startsWith("/")) return "/";
  if (path.startsWith("//")) return "/";
  return path;
}

export function buildLoginHref(redirectTo?: string | null): string {
  const target = sanitizeInternalPath(redirectTo);
  if (target === "/") return "/login";
  return `/login?redirectTo=${encodeURIComponent(target)}`;
}

export function navigateToLogin(
  router: RouterLike,
  options?: NavigateToLoginOptions,
): void {
  const href = buildLoginHref(options?.redirectTo);
  if (options?.replace) {
    router.replace(href);
    return;
  }
  router.push(href);
}

interface NavigateToPathOptions {
  replace?: boolean;
}

export function navigateToInternalPath(
  router: RouterLike,
  path: string | null | undefined,
  options?: NavigateToPathOptions,
): void {
  const safePath = sanitizeInternalPath(path);
  if (options?.replace) {
    router.replace(safePath);
    return;
  }
  router.push(safePath);
}

export function navigateToHome(
  router: RouterLike,
  options?: NavigateToPathOptions,
): void {
  navigateToInternalPath(router, "/", options);
}
